export {
  unstable_HistoryRouter as Router,
  // BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
